import React from 'react';
import { Box, Button } from '@mui/material';

interface FooterActionsProps {
  onSave?: () => void;
  onDiscard?: () => void;
  onRegenerate?: () => void;
  saveDisabled?: boolean;
  regenerateDisabled?: boolean;
  regenerateDisabledReason?: string;
  sidebarWidth?: number;
  showButtons?: boolean;
}

const FooterActions: React.FC<FooterActionsProps> = ({
  onSave,
  onDiscard,
  saveDisabled,
  sidebarWidth = 282, // Default sidebar width from SidebarNavigation
  showButtons = true,
}) => {
  if (!showButtons) return null;
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: sidebarWidth,
        right: 0,
        height: 70,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 1.5,
        px: 3,
        py: 0.5,
        backgroundColor: 'background.paper',
        borderTop: '1px solid #e0e0e0',
        zIndex: 100,
      }}
    >
      {showButtons && (
        <>
          <Button
            variant="outlined"
            onClick={onDiscard}
            disabled={!onDiscard}
            sx={{
              textTransform: 'none',
              height: 40,
              px: 2,
              borderColor: '#1A55F9',
              color: '#1A55F9',
              '&:hover': {
                backgroundColor: '#F5F5F5',
                borderColor: '#1A55F9',
              },
              '&.Mui-disabled': {
                opacity: 0.5,
                borderColor: '#1A55F9 !important',
                color: '#1A55F9 !important',
                backgroundColor: 'transparent !important',
              },
            }}
          >
            Discard
          </Button>

          <Button
            variant="contained"
            onClick={onSave}
            disabled={!onSave || !!saveDisabled}
            sx={{
              textTransform: 'none',
              height: 40,
              px: 3,
              backgroundColor: '#1A55F9',
              color: '#FFFFFF',
              '&:hover': {
                backgroundColor: '#1A45C6',
              },
              '&.Mui-disabled': {
                opacity: 0.5,
                backgroundColor: '#1A55F9 !important',
                color: '#FFFFFF !important',
              },
            }}
          >
            Save
          </Button>
        </>
      )}
    </Box>
  );
};

export default FooterActions;
